import HighlightText from '@atoms/HighlightText/HighlightText';
import Text from '@atoms/Text/Text';
import type { Suggestion } from '@occ/api-client';
import { StyledFullAddressListItem } from './FullAddressListItem.styles';

export type FullAddressListItemProps = {
  suggestion: Suggestion;
  searchTerm: string;
  onItemClick: (suggestion: Suggestion) => void;
};

const FullAddressListItem = ({ suggestion, searchTerm, onItemClick }: FullAddressListItemProps) => {
  const { street, street_number, letter, postalcode, locality } = suggestion;

  return (
    <StyledFullAddressListItem data-testid="full-address-list-item" onClick={() => onItemClick(suggestion)}>
      <Text type="subhead">
        <HighlightText text={`${street} ${street_number}${letter} `} term={searchTerm} />
      </Text>
      <Text type="body" size="small">
        <HighlightText text={`${postalcode} `} term={searchTerm} />
        <HighlightText text={`${locality}`} term={searchTerm} />
      </Text>
    </StyledFullAddressListItem>
  );
};

export default FullAddressListItem;
